/* Tysk katalog for locale-invoice-list-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'inv.title': 'Rechnungsliste',
  'inv.titleHelp': 'Übersicht über Rechnungen, Angebote, Auftragsbestätigungen und Gutschriften für das gewählte Geschäftsjahr.',
  'inv.searchPh': 'Nach Rechnungsnummer, Kunde oder Betrag suchen',
  'inv.searchHelp': 'Durchsuche die Liste nach Rechnungsnummer, Kundenname, Rechnungsbetrag, Nettobetrag, bezahltem Betrag oder Restbetrag.',
  'inv.downloadHelp': 'Lade die Liste für den gewählten Tab und Filter herunter.',
  'inv.addHelp': 'Erstelle eine neue Rechnung.',
  'inv.add': 'Neue Rechnung',
  'inv.filterHelp': 'Filtere die Liste nach Status, Dokumenttyp, Datum, Zeitraum, Betrag und Archiv.',
  'inv.tabsHelpTitle': 'Dokumenttypen',
  'inv.tabsHelp': 'Wechsle zwischen Rechnung, Entwurf, Angebot/Auftragsbestätigung, Gutschrift und Verkaufsbericht.',
  'inv.listHelpTitle': 'Die Rechnungsliste',
  'inv.listHelp': 'Jede Zeile ist ein Dokument aus dem Backend. Tippe auf eine Zeile für Details und Aktionen.',
  'inv.loading': 'Rechnungen werden geladen',
  'inv.loadingSub': 'Daten werden aus dem Backend abgerufen.',
  'inv.noMatch': 'Keine Treffer hier',
  'inv.noMatchSub': 'Versuche einen anderen Tab oder setze den Filter zurück.',
  'inv.backToVouchers': 'Zurück zu Transaktionen',
  'inv.type.invoice': 'Rechnung',
  'inv.type.quote': 'Angebot',
  'inv.type.orderConfirmation': 'Auftragsbestätigung',
  'inv.type.creditNote': 'Gutschrift',
  'inv.type.unknown': 'Dokument',
  'inv.tab.salesReport': 'Verkaufsbericht',
  'inv.importHistory.tab': 'Importierter Verlauf',
  'inv.importHistory.loading': 'Importierter Rechnungsverlauf wird geladen …',
  'inv.importHistory.error': 'Der importierte Rechnungsverlauf konnte nicht geladen werden.',
  'inv.importHistory.readOnly': 'Dies ist schreibgeschützter Verlauf aus dem früheren System. Die Einträge wirken sich nicht auf Buchhaltung oder MwSt. aus und haben in Plumme keine Rechnungsaktionen.',
  'inv.importHistory.documents': 'Dokumente',
  'inv.importHistory.year': 'Importierter Verlauf für {year}',
  'inv.importHistory.netSales': 'Nettoumsatz',
  'inv.importHistory.customers': 'Kunden',
  'inv.importHistory.creditNotes': 'Gutschriften',
  'inv.importHistory.netIncluded': 'Vom Nettoumsatz abgezogen',
  'inv.importHistory.search': 'Nach Rechnungsnummer oder Kunde suchen',
  'inv.importHistory.empty': 'Keine importierten Rechnungsdetails für dieses Jahr',
  'inv.importHistory.emptySub': 'Importierte Buchhaltungszahlen werden weiterhin in Berichten und Empfehlungen verwendet, sofern vorhanden.',
  'inv.importHistory.detailTitle': 'Details aus der Importdatei',
  'inv.importHistory.dueDate': 'Fälligkeitsdatum',
  'inv.importHistory.paidDate': 'Ausgleichsdatum',
  'inv.importHistory.remaining': 'Ausstehend',
  'inv.importHistory.lines': 'Importierte Positionen',
  'inv.importHistory.noLines': 'Das Quellsystem hat für dieses Dokument nur Rechnungssummen geliefert.',
  'inv.importHistory.markSettled': 'Als ausgeglichen markieren',
  'inv.importHistory.reopenStatus': 'Status wieder öffnen',
  'inv.importHistory.manualSettledNote': 'In Plumme ohne Buchung als ausgeglichen markiert.',
  'inv.importHistory.settledToast': 'Die importierte Rechnung ist als ausgeglichen markiert.',
  'inv.importHistory.reopenedToast': 'Die importierte Rechnung wurde wieder geöffnet.',
  'inv.importHistory.statusError': 'Die importierte Rechnung konnte nicht aktualisiert werden.',
  'inv.importHistory.sourceNote': 'Aus dem früheren System importiert – das Dokument befindet sich in der Importdatei.',
  'inv.importHistory.creditReference': 'Importierte Gutschrift aus dem früheren System – schreibt Rechnung {number} gut.',
  'inv.importHistory.creditedReference': 'Aus dem früheren System importiert · gutgeschrieben mit Gutschrift {number}',
  'inv.importHistory.reanalysisTitle': 'Importierter Rechnungsverlauf muss neu analysiert werden',
  'inv.importHistory.reanalysisBody': 'Die gespeicherte Analyse stammt aus der Zeit, bevor Gutschriften aus eigenen Gutschrift-Blättern gelesen wurden. Die Quelldaten werden nicht geändert.',
  'inv.importHistory.reanalysisAction': 'Zur Neuanalyse',
  'inv.importHistory.rowSource': 'Aus dem früheren System importiert',
  'adv.sales.importedHistoryNote': 'Die Analyse kombiniert gebuchte Plumme-Rechnungen mit schreibgeschütztem Verkaufsverlauf aus dem Import. Gutschriften sind abgezogen. {coverage}',
  'adv.sales.importedTotalsCoverage': 'Der Import enthält Rechnungssummen, aber nicht für alle Dokumente Produktpositionen.',
  'adv.sales.importedLinesCoverage': 'Der Import enthält für Teile des Verlaufs auch Rechnungspositionen.',
  'inv.tab.drafts': 'Entwürfe',
  'inv.filterDocType': 'Dokumenttyp',
  'inv.filterArchive': 'Archiv',
  'inv.filterSeeArchived': 'Archivierte anzeigen',
  'inv.status.draft': 'Entwurf',
  'inv.status.created': 'Nicht gesendet',
  'inv.status.sent': 'Gesendet',
  'inv.status.accepted': 'Angenommen',
  'inv.status.confirmed': 'Bestätigt',
  'inv.status.paid': 'Bezahlt',
  'inv.status.unpaid': 'Nicht bezahlt',
  'inv.status.overdue': 'Überfällig',
  'inv.status.credited': 'Gutgeschrieben',
  'inv.kpi.invoiceCount': 'Rechnungen',
  'inv.kpi.invoiceCount.help': 'Anzahl der Rechnungen, die du im gewählten Jahr erstellt hast, unabhängig vom Status.',
  'inv.kpi.revenue': 'Umsatz',
  'inv.kpi.revenue.help': 'Summe aller Rechnungen ohne MwSt. im Jahr.',
  'inv.kpi.notSent': 'Nicht gesendet',
  'inv.kpi.notSent.help': 'Rechnungen, die als Entwurf vorliegen und auf den Versand warten.',
  'inv.kpi.credited': 'Gutgeschrieben',
  'inv.kpi.credited.help': 'Anzahl der Gutschriften.',
  'inv.kpi.quotes': 'Angebote',
  'inv.kpi.quotes.help': 'Anzahl der Angebote im Jahr.',
  'inv.kpi.accepted': 'Angenommen',
  'inv.kpi.accepted.help': 'Anzahl der Angebote, die der Kunde angenommen hat.',
  'inv.kpi.orders': 'Auftragsbestätigungen',
  'inv.kpi.orders.help': 'Anzahl der Auftragsbestätigungen im Jahr.',
  'inv.kpi.creditNotes': 'Gutschriften',
  'inv.kpi.creditNotes.help': 'Anzahl der Gutschriften im Jahr.',
  'inv.kpi.value': 'Wert',
  'inv.kpi.value.help': 'Gesamtwert ohne MwSt. der Dokumente in diesem Tab.',
  'inv.kpi.amount': 'Betrag',
  'inv.kpi.amount.help': 'Gesamtbetrag ohne MwSt. der Gutschriften.',
  'inv.kpi.sent': 'Gesendet',
  'inv.kpi.sent.help': 'Anzahl der Dokumente, die an den Kunden gesendet wurden.',
  'inv.kpi.confirmed': 'Bestätigt',
  'inv.kpi.confirmed.help': 'Auftragsbestätigungen, die der Kunde bestätigt hat.',
  'inv.kpi.drafts': 'Entwürfe',
  'inv.kpi.drafts.help': 'Dokumente, die noch nicht gesendet wurden.',
  'inv.kpi.potentialRevenue': 'Möglicher Umsatz',
  'inv.kpi.potentialRevenue.help': 'Gesamtwert der Entwürfe, die noch gesendet werden können.',
  'inv.kpi.customers': 'Kunden',
  'inv.kpi.customers.help': 'Anzahl eindeutiger Kunden in den Entwürfen.',
  'inv.kpi.history': 'Alter',
  'inv.kpi.history.help': 'Wie lange der älteste Entwurf schon wartet.',
  'inv.kpi.sub.totalYear': 'Gesamt dieses Jahr',
  'inv.kpi.sub.exVat': 'Ohne MwSt.',
  'inv.kpi.sub.waiting': 'Wartet auf dich',
  'inv.kpi.sub.creditNotes': 'Gutschriften',
  'inv.kpi.sub.started': 'Begonnene Dokumente',
  'inv.kpi.sub.uniqueCustomers': 'Eindeutige Kunden',
  'inv.kpi.sub.oldestDraft': 'Ältester Entwurf',
  'inv.kpi.sub.noDrafts': 'Keine Entwürfe',
  'inv.kpi.sub.none': 'Keine',
  'inv.kpi.sub.days': '{n} Tage',
  'inv.kpi.sub.sentQuotes': 'Gesendete Angebote',
  'inv.kpi.sub.accepted': 'Angenommene',
  'inv.kpi.sub.confirmed': 'Bestätigte',
  'inv.kpi.sub.notSent': 'Nicht gesendet',
  'inv.kpi.sub.sent': 'Gesendete',
  'inv.col.document': 'Dokument',
  'inv.col.invoice': 'Rechnung',
  'inv.col.date': 'Datum',
  'inv.col.net': 'Netto',
  'inv.col.amount': 'Betrag',
  'inv.col.status': 'Status',
  'inv.col.number': 'Nr.',
  'inv.col.customer': 'Kunde',
  'inv.netInline': 'Netto {amount}',
  'inv.draftPlaceholder': 'ENTWURF',
  'inv.detail.dueTitle': 'Fälligkeit',
  'inv.detail.dueHelp': 'Das Datum, bis zu dem das Dokument gilt oder bis zu dem bezahlt werden muss.',
  'inv.detail.statusHelp': 'Zahlungen stammen aus gebuchten PaymentEntry-Einträgen. Angebote und Auftragsbestätigungen zeigen den Durchführungsstatus.',
});
